import {
  Client,
} from '@microsoft/microsoft-graph-client';

let graphClient;

const ensureClient = (authProvider) => {
  if (!graphClient) {
    graphClient = Client.initWithMiddleware({
      authProvider,
    });
  }

  return graphClient;
};

export const getUser = async (authProvider) => {
  ensureClient(authProvider);

  const user = await graphClient.api('/me')
    .select('displayName,mail,userPrincipalName')
    .get();

  return user;
};
